import { useSnackbarStore } from "@/store/snackbar.store";
import type { SnackbarTarget } from "@/store/snackbar.store";
import { usePipStore } from "@/store/pip.store";

export function useCopy() {
  const { showSnackbarError, showSnackbarSuccess } = useSnackbarStore();
  const pipStore = usePipStore();

  async function copy(text: string, successMessage = "Copied successfully") {
    const targetWindow = pipStore.getFocusedWindow();
    const target: SnackbarTarget = targetWindow === window ? "main" : "pip";

    try {
      await targetWindow.navigator.clipboard.writeText(text);
      showSnackbarSuccess(successMessage, target);
    } catch (error) {
      showSnackbarError("Failed copy to clipboard", -1, target);
    }
  }

  return { copy };
}
